import { ExperienceName, type IExperience } from '~/features-shared/experience/interfaces/experience'

const PROJECT: IExperience = {
  name: ExperienceName.PROJECT,
  serviceName: '3dplan',
  appId: 'ENXPLAN_AP',
  label: 'experienceProjectLabel',
  icon: 'chart-gantt',
  color: '#368EC4',
  order: 10,
}

const DATA_PERSPECTIVE: IExperience = {
  name: ExperienceName.DATA_PERSPECTIVE,
  serviceName: '3danalytics',
  appId: 'EXA_AEP_AP',
  label: 'experienceDataPerspectiveLabel',
  icon: 'chart-line-bar-combine',
  color: '#FF8A2E',
  order: 11,
}

const MEDIA_SPOTLIGHT: IExperience = {
  name: ExperienceName.MEDIA_SPOTLIGHT,
  serviceName: '3DSWYM',
  appId: 'X3DMCTY_AP',
  label: 'experienceMediaSpotlightLabel',
  icon: 'picture-favorite',
  color: '#6D2815',
  order: 12,
}

const ISSUE_MANAGEMENT: IExperience = {
  name: ExperienceName.ISSUE_MANAGEMENT,
  serviceName: '3DSpace',
  appId: 'ENXISSU_AP',
  label: 'experienceIssueManagementLabel',
  icon: 'issue-type',
  color: '#6FBC4B',
  order: 13,
}

const BOOKMARK_EDITOR: IExperience = {
  name: ExperienceName.BOOKMARK_EDITOR,
  serviceName: '3DSpace',
  appId: 'ENOFOL4_AP',
  label: 'experienceBookmarkEditorLabel',
  icon: 'bookmark',
  color: '#4EA8B7',
  order: 14,
}

const DOCUMENT_MANAGEMENT: IExperience = {
  name: ExperienceName.DOCUMENT_MANAGEMENT,
  serviceName: '3DSpace',
  appId: 'ENXWDOC_AP',
  label: 'experienceDocumentManagementLabel',
  icon: 'doc-user',
  color: '#9B2C98',
  order: 15,
}

const CONSTRUCTION_PLANNING_BOARD: IExperience = {
  name: ExperienceName.CONSTRUCTION_PLANNING_BOARD,
  serviceName: '3dlean',
  appId: 'DELCPBC_AP',
  label: 'experienceConstructionPlanningBoardLabel',
  icon: 'app-3dlean-construction',
  color: '#F564A3',
  order: 16,
}

const THREEDLEAN: IExperience = {
  name: ExperienceName.THREEDLEAN,
  serviceName: '3dlean',
  appId: 'DEL3DWC_AP',
  label: 'experienceThreeDLeanLabel',
  icon: 'app-3dlean',
  color: '#002596',
  order: 17,
}

export const DEFAULT_EXPERIENCES_GA: IExperience[] = [
  PROJECT,
  DATA_PERSPECTIVE,
  MEDIA_SPOTLIGHT,
]

export const DEFAULT_EXPERIENCES_LA: IExperience[] = [
  ISSUE_MANAGEMENT,
  BOOKMARK_EDITOR,
  DOCUMENT_MANAGEMENT,
  CONSTRUCTION_PLANNING_BOARD,
  THREEDLEAN,
]

export const ALL_DEFAULT_EXPERIENCES: IExperience[] = [
  ...DEFAULT_EXPERIENCES_GA,
  ...DEFAULT_EXPERIENCES_LA,
]

/**
 * List of web-only experiences
 *
 * Contains all experiences that are not supported on desktop/mobile native app.
 */
export const WEB_ONLY_EXPERIENCES: ExperienceName[] = []
